import { el, mount, unmount } from 'redom';

import serverInterface from 'server-interface';

import { stringToSVG } from 'utilities';
import { preventPropogation } from 'utilities/dom';

import Tooltip from '../tooltip';

import presentScreenIconString from 'assets/images/present-screen-icon.svg?raw';

const presentScreenIcon = stringToSVG(presentScreenIconString);
const stopPresentingScreenIcon = stringToSVG(presentScreenIconString);

const eventTypes = {
  STARTED: 'presenting-started',
  STOPPED: 'presenting-stopped',
  PAUSED: 'presenting-paused',
  UNPAUSED: 'presenting-unpaused'
};

class ScreenPresenterControls {

  constructor(meetingSession, observers, meeting) {

    this.paused = true;
    this.meetingSession = meetingSession;
    this.observers = observers;
    this.meeting = meeting;

    this.startButton = el('button.start-screen-presenting-button.meeting-room-control', [presentScreenIcon.cloneNode(true)]);
    this.stopButton = el('button.stop-screen-presenting-button.meeting-room-control', [stopPresentingScreenIcon.cloneNode(true)]);

    this.startButton.addEventListener('click', this.presentScreen.bind(this));
    this.startButton.addEventListener('dblclick', preventPropogation);

    this.stopButton.addEventListener('click', this.stopPresenting.bind(this));
    this.stopButton.addEventListener('dblclick', preventPropogation);

    this.startButtonWithTooltip = new Tooltip(this.startButton, '.present-screen-start-button-tooltip', 'Start presenting');
    this.stopButtonWithTooltip = new Tooltip(this.stopButton, '.present-screen-stop-button-tooltip', 'Stop presenting');

    this.el = el('.screen-presenter-controls-main');

    this.addStartButton();

  }

  addStartButton() {

    mount(this.el, this.startButtonWithTooltip);

  }

  removeStartButton() {

    unmount(this.el, this.startButtonWithTooltip);

  }

  addStopButton() {

    mount(this.el, this.stopButtonWithTooltip);

  }

  removeStopButton() {

    unmount(this.el, this.stopButtonWithTooltip);

  }

  async presentScreen(event) {

    event.stopPropagation();

    const screenPresenterControls = this;

    try {

      const stream = await this.meetingSession.audioVideo.startContentShareFromScreenCapture();

      const postId = this.meeting.postId;
      const videoTrack = stream.getVideoTracks()[0];
      const videoSettings = videoTrack.getSettings();

      await serverInterface.startup.community.singleProducerMeeting.updateSingleProducerMeetingHostVideoSettingsByPostId(postId, videoSettings);

      stream.oninactive = function onScreenStreamEnd() {
        screenPresenterControls.reflectPresentingStoppedInState();
      };

      this.removeStartButton();
      this.addStopButton();

      this.paused = false;

      this.observers.started();

    } catch (exception) {

    }

  }

  reflectPresentingStoppedInState() {

    this.removeStopButton();
    this.addStartButton();

    this.paused = true;

    this.observers.stopped();

  }

  async stopPresenting(event) {

    event.stopPropagation();

    try {

      const result = await this.meetingSession.audioVideo.stopContentShare();

      this.reflectPresentingStoppedInState();

    } catch (exception) {
      console.log(exception);
    }

  }

}

ScreenPresenterControls.eventTypes = eventTypes;

export default ScreenPresenterControls;